"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioFilter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreLinkWithIcon = _interopRequireDefault(require("@legacy-vfuk/core-link-with-icon"));

var _coreSpacing = _interopRequireDefault(require("@legacy-vfuk/core-spacing"));

var _coreRadioButtonList = _interopRequireDefault(require("@legacy-vfuk/core-radio-button-list"));

var _reactI18next = require("react-i18next");

var _locales = require("../../locales");

var _FilterSection = _interopRequireDefault(require("../FilterSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RadioFilter = /*#__PURE__*/function (_PureComponent) {
  _inherits(RadioFilter, _PureComponent);

  var _super = _createSuper(RadioFilter);

  function RadioFilter() {
    var _this;

    _classCallCheck(this, RadioFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleOnChange = function (event) {
      // Get the value of the checked radio button
      var checkedValue = event.target.value; // Call the onChange callback with the filter id and the updated checked value

      _this.props.onChange(_this.props.id, _objectSpread(_objectSpread({}, _this.radioFilter), {}, {
        checked: checkedValue
      }));
    };

    _this.handleReset = function () {
      _this.props.onChange(_this.props.id, _objectSpread(_objectSpread({}, _this.radioFilter), {}, {
        checked: undefined
      }));
    };

    return _this;
  }

  _createClass(RadioFilter, [{
    key: "radioFilter",
    get: function get() {
      return {
        title: this.props.title,
        id: this.props.id,
        subText: this.props.subText,
        options: this.props.options,
        items: this.props.items,
        checked: this.props.checked,
        type: 'radio'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(_FilterSection["default"], {
        id: this.props.id,
        title: this.props.title,
        subText: this.props.subText,
        numberOfActiveFilters: this.props.checked ? 1 : 0
      }, /*#__PURE__*/_react["default"].createElement(_coreRadioButtonList["default"], {
        fieldWrapper: {
          label: this.props.options.groupName,
          showLabel: false
        },
        radioButtons: {
          id: this.props.id,
          items: this.props.items,
          checked: this.props.checked,
          groupName: this.props.options.groupName,
          onChange: function onChange(event) {
            _this2.handleOnChange(event);
          }
        }
      }), this.props.showReset ? /*#__PURE__*/_react["default"].createElement(_coreSpacing["default"], {
        spacingLevel: {
          top: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], {
        text: this.props.t('Reset filter'),
        icon: {
          name: 'refresh',
          justify: 'left'
        },
        onClick: this.handleReset
      })) : null);
    }
  }]);

  return RadioFilter;
}(_react.PureComponent);

exports.RadioFilter = RadioFilter;
RadioFilter.displayName = "RadioFilter";

var _default = (0, _reactI18next.withTranslation)(_locales.componentName)(RadioFilter);

exports["default"] = _default;
//# sourceMappingURL=RadioFilter.js.map